import React, { createContext, useState } from "react";

const DashboardContext = createContext(null);

function move(array, oldIndex, newIndex) {
	if (newIndex >= array.length) {
		newIndex = array.length - 1;
	}
	array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
	return array;
}

function moveElement(array, index, offset) {
	const newIndex = index + offset;
	return move(array, index, newIndex);
}

const DashboardContextProvider = ({ props, children }) => {
	let [blocks, setBlocks] = useState([]);

	const moveItem = (sourceId, destinationId) => {
		const sourceIndex = blocks.findIndex((item) => item.store_id === sourceId);

		const destinationIndex = blocks.findIndex(
			(item) => item.store_id === destinationId
		);

		// If source/destination is unknown, do nothing.
		if (sourceId === -1 || destinationId === -1) {
			return;
		}

		const offset = destinationIndex - sourceIndex;

		let newArr = moveElement([...blocks], sourceIndex, offset);
		setBlocks(newArr);
	};

	return (
		<DashboardContext.Provider
			value={{
				blocks,
				setBlocks,
				moveItem,
			}}
		>
			{children}
		</DashboardContext.Provider>
	);
};

export { DashboardContext, DashboardContextProvider };
